import * as React from "react";
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import { Chip } from '@material-ui/core';

export const BooleanField = (props) => {
  const { source } = props;
  const record = useRecordContext(props);

  const now = Date.now();
  let userBlockDate;
  if (record.expire_block) {
    userBlockDate = Date.parse(record.expire_block);
  }
  let isBlocked = record[source];
  if (userBlockDate) {
    isBlocked = userBlockDate > now;
  }

  let label = "Bloqueado";
  let color = "#fff0f0";
  if (!isBlocked) {
    label = "Aprovado";
    color = "#eefee6";
  }

  return <Chip
    label={label}
    size="small"
    style={{
      backgroundColor: color,
      border: 0
    }}
  />;
};

BooleanField.propTypes = {
  record: PropTypes.object,
};